import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface Settings {
  stockMode: boolean;
  priceMode: boolean;
  companyName?: string;
  email?: string;
  phone?: string;
  address?: string;
}

interface SettingsState {
  settings: Settings;
  loading: boolean;
  error: string | null;
}

const mockSettings = {
  stockMode: true,
  priceMode: false,
  companyName: 'Rezlive Admin',
  email: 'admin@bizon.com',
  phone: '+1 (555) 123-4567',
  address: '123 Business St, City, State 12345',
};

const initialState: SettingsState = {
  settings: mockSettings,
  loading: false,
  error: null,
};

export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    return mockSettings;
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch settings';
      });
  },
});

export default settingsSlice.reducer; 